import { render, staticRenderFns } from "./Compta.vue?vue&type=template&id=2dc45e3e&scoped=true&"
import script from "./Compta.vue?vue&type=script&lang=js&"
export * from "./Compta.vue?vue&type=script&lang=js&"
import style0 from "./Compta.vue?vue&type=style&index=0&id=2dc45e3e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc45e3e",
  null
  
)

export default component.exports